module.exports = __webpack_public_path__ + "assets/img/e1b1-gt.svg";